import { mapToNamedProperty, NamedProperty } from "sprint-common-web";

import { SystemLookupResponse } from "../api/orders-api/system/GetSystemsLookupResponse";

export interface System {
    id: string;
    name: string;
    integrator: NamedProperty;
}

export const mapToSystem = (response: SystemLookupResponse): System => ({
    id: response.id,
    name: response.name,
    integrator: mapToNamedProperty(response.integrator)
});
